// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"40f18485","200":"c59109d5","211":"656946d2","213":"afaf89b8","239":"da93795d","361":"89c3ca45","380":"10e57469","433":"b97d367c","453":"d94261f7","455":"1e09c43e","468":"ffa7a831","536":"4be581c7","787":"2ce03cf7","971":"8ecd8c5d"}[chunkId] + ".chunk.js";
};